import React, { useEffect, useState,useContext } from "react";
import "./Mid-Section-Pc.scss";

//import components
import MonthYearPicker from "../../Payments/Mobile-and-Tablet/MonthPicker.jsx";
import DonutPercentage from "../../OverView/Pc-and-Large-Screens/DonutPercentage.jsx";
import TenantTable from "./TenantTable.jsx";

//import icons
import { IoPersonAddOutline } from "react-icons/io5";
import { CgArrowsExchange } from "react-icons/cg";
import { IoPersonRemoveOutline } from "react-icons/io5";
import { CiEdit } from "react-icons/ci";
import TenantModificationModal from "../Mobile-and-Tablet/TenantModal.jsx";

//import context
import { MyContext } from "../../../../tenantsDashContext.jsx";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

import {
  getProperty,
} from "../../../../redux/slices/sliceActions";

const MidSectionTenants = () => {
  //context
  const { curerntYear,currentMonth, monthNames,selectedDate,setSelectedDate,rolesAssigned } = useContext(MyContext);


  //data fetched
  const dispatch = useDispatch();
  const { user, profile, tenants } = useSelector(
    (state) => state.landlordslice
  );
  const token = user?.accessToken;
  const id = user?.user?.user_id;
  const property_id = user?.user?.propertyId;

  const [percentageOccupied, setPercentageOccupied] = useState(0);
  const [percentageVacant, setPercentageVacant] = useState(0);
  const [occupiedHouses, setOccupiedHouses] = useState(0);
  const [vacantHouses, setVacantHouses] = useState(0);

  const [latestInvoice, setLatestInvoice] = useState([]);
  const [paymentProgress, setPaymentProgress] = useState([]);

  useEffect(() => {
    // console.log("muimi", profile);
    setPercentageOccupied(
      (profile.occupiedHouses / profile.totalHouses) * 100 || 0
    );
    setPercentageVacant(
      ((profile.totalHouses - profile.occupiedHouses) / profile.totalHouses) *
        100 || 0
    );
    setOccupiedHouses(profile.occupiedHouses);
    setVacantHouses(profile.totalHouses - profile.occupiedHouses);

    setLatestInvoice(profile.unpaidInvoices);
    setPaymentProgress(profile.paidInvoices?.[0]);

    dispatch(getProperty({ id: property_id, token }))

  }, [profile]);

  


  //individual card data
  const invoicePendingDetails = {
    Title: "Invoices Pending",
    rent: latestInvoice?.rent || "0",
    water: latestInvoice?.water || "0",
    arrears: latestInvoice?.arrears || "0",
    serviceCharge: latestInvoice.serviceCharge || "0",
    unpaidDeposit: latestInvoice.unpaidDeposit || "0",
    garbage: latestInvoice?.garbage || "0",
    totalAmount:
      (latestInvoice?.rent || 0) +
      (latestInvoice?.water || 0) +
      (latestInvoice?.arrears || 0) +
      // (latestInvoice.serviceCharge || 0) +
      // (latestInvoice.unpaidDeposit || 0) +
      (latestInvoice?.garbage || 0),
  };

  const invoicePaidDetails = {
    Title: "Invoices Paid",
    rent: Number(paymentProgress?.rent_amount) || "0",
    water: Number(paymentProgress?.water_bill_amount) || "0",
    arrears: Number(paymentProgress?.arrears_amount) || "0",
    serviceCharge: Number(paymentProgress?.service_fee_amount) || "0",
    unpaidDeposit: Number(paymentProgress?.unpaidDeposit) || "0",
    garbage: Number(paymentProgress?.garbage_charge_amount) || "0",
    totalAmount:
      Number(paymentProgress?.rent_amount || 0) +
      Number(paymentProgress?.water_bill_amount || 0) +
      Number(paymentProgress?.arrears_amount || 0) +
      // (paymentProgress.serviceCharge || 0) +
      // (paymentProgress.unpaidDeposit || 0) +
      Number(paymentProgress?.garbage_charge_amount || 0),
  };

  const totalValueDetails = {
    rent: invoicePaidDetails.rent,
    water: invoicePaidDetails.water,
    arrears: invoicePaidDetails.arrears,
    serviceCharge: invoicePaidDetails.serviceCharge,
    unpaidDeposit: invoicePaidDetails.unpaidDeposit,
    garbage: invoicePaidDetails.garbage,
    otherCharges:Number(invoicePaidDetails.arrears) + Number(invoicePaidDetails.serviceCharge) + Number (invoicePaidDetails.unpaidDeposit) + Number(invoicePaidDetails.garbage),
    totalAmount:
      invoicePendingDetails?.totalAmount + invoicePaidDetails?.totalAmount,
  };

  const total = totalValueDetails?.totalAmount;

  const totalIndividuals = [
    (invoicePaidDetails?.rent + invoicePendingDetails?.rent),
    Number(invoicePaidDetails?.water) + Number(invoicePendingDetails?.water),
    Number(invoicePaidDetails?.arrears) + Number(invoicePendingDetails?.arrears)+
    Number( invoicePaidDetails?.garbage + Number(invoicePendingDetails?.garbage))+
    Number(invoicePaidDetails?.serviceCharge) +
      Number(invoicePendingDetails?.serviceCharge) +
      Number(invoicePaidDetails?.unpaidDeposit) +
      Number(invoicePendingDetails?.unpaidDeposit),
  ];





  const [showModal, setShowModal] = useState(false);
  const [action, setAction] = useState("");
  const [tenantData, setTenantData] = useState({});

  const handleShowModal = (actionType) => {
    setAction(actionType);
    setShowModal(true);
  };

  return (
    <div className="mid-section-Tenants-pc">
      <div className="title">
        Your Reports
        <div className="description">Invoice and payment information</div>
      </div>
      <div className="cards-container">
        <div className="individual-card">
          <div className="top-card-section">
            <div className="top-left">
              <div className="title">Tenant Information</div>
              <div className="number">{occupiedHouses} Tenants</div>
              <div className="date">
                <MonthYearPicker
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                />
              </div>
            </div>
            <div className="top-right">
              <div className="apartment">
                <select
                  id="apartment-select"
                  name="apartment"
                  className="apartment-dropdown"
                >
                  <option value="apartment1">Apartment 1</option>
                  <option value="apartment2">Apartment 2</option>
                  <option value="apartment3">Apartment 3</option>
                </select>
              </div>
            </div>
          </div>
          <div className="bottom-card-section">
            <div className="bottom-left">
              <DonutPercentage
                percentage={percentageOccupied.toFixed(1)}
                donutSize={"80%"}
                setColors={["#192A3A", "#B39359"]}
              />
            </div>
            <div className="bottom-right">
              <div className="section">
                <div className="shape-and-text">
                  <div className="shape"></div>
                  <div className="title-and-details">
                    <div className="title">Occupied Houses</div>
                    <div className="details">{occupiedHouses}</div>
                  </div>
                </div>
                <div className="shape-container">
                  <div
                    className="shape-2"
                    style={{
                      width: `${percentageOccupied * (80 / 100) + 2}px `,
                    }}
                  ></div>
                  <div className="text">{percentageOccupied.toFixed(1)}%</div>
                </div>
              </div>
              <div className="section second-section">
                <div className="shape-and-text">
                  <div className="shape"></div>
                  <div className="title-and-details">
                    <div className="title">Vacant Houses</div>
                    <div className="details">{vacantHouses}</div>
                  </div>
                </div>
                <div className="shape-container">
                  <div
                    className="shape-2"
                    style={{ width: `${percentageVacant * (80 / 100) + 2}px ` }}
                  ></div>
                  <div className="text">{percentageVacant.toFixed(1)}%</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="individual-card progress-report-card">
          <div className="title">Payments Progress</div>
          <div className="progress">
            <div className="progress-container">
              <div className="subtitle-and-shape">
                <div className="individual">Rent</div>
                <div className="shape">
                  <div style={{ height: "100%", width: `${(((totalValueDetails?.rent / (invoicePendingDetails?.rent + totalValueDetails?.rent)) * 100).toFixed(1)|| 0)}%` }}>
                    <div
                      className="inner-shape"
                      style={{
                        backgroundColor: "#192A3A",
                        height: "100%",
                        width: "100%",
                        borderRadius: "5px",
                      }}
                    ></div>
                  </div>
                </div>
              </div>
              <div className="amount">{ totalValueDetails?.rent}</div>
            </div>
            <div className="progress-container">
              <div className="subtitle-and-shape">
                <div className="individual">Water</div>
                <div className="shape">
                  <div style={{ height: "100%",width: `${(((totalValueDetails?.water /  (invoicePendingDetails?.water + totalValueDetails?.water)) * 100).toFixed(1)|| 0)}%` }}>
                    <div
                      className="inner-shape"
                      style={{
                        backgroundColor: "#B39359",
                        height: "100%",
                        width: "100%",
                        borderRadius: "5px",
                      }}
                    ></div>
                  </div>
                </div>
              </div>
              <div className="amount">{ totalValueDetails?.water}</div>
            </div>
            <div className="progress-container">
              <div className="subtitle-and-shape">
                <div className="individual">Other Charges</div>
                <div className="shape">
                  <div style={{ height: "100%",width: `${(((totalValueDetails?.otherCharges / totalIndividuals[2])||0) * 100)}%` }}>
                    <div
                      className="inner-shape"
                      style={{
                        backgroundColor: "#64A371",
                        height: "100%",
                        width: "100%",
                        borderRadius: "5px",
                      }}
                    ></div>
                  </div>
                </div>
              </div>
              <div className="amount">{ totalValueDetails?.otherCharges}</div>
            </div>
          </div>
          <div className="boundery">
            <div className="amount">0%</div>
            <div className="amount">25%</div>
            <div className="amount">50%</div>
            <div className="amount">75%</div>
            <div className="amount">100%</div>
          </div>
        </div>
        <div className="individual-card actions-container">
          <div className="title">Actions </div>
          <div className="options-container">
            <div
              //check permision to set class name
              className={`option ${rolesAssigned?.manageTenants ? '' : 'disabled-option'}`}
              // className={`option  disabled-option`}
              onClick={() => {
                if (rolesAssigned?.manageTenants) {
                  handleShowModal("create new tenant")
                }
              }}
              disabled={true}
            >
              <div className="icon-container">
                <IoPersonAddOutline />
              </div>
              <div className="text">Add</div>
            </div>
            <div
              className={`option alternate-option ${rolesAssigned?.manageTenants ? '' : 'disabled-option'}`}
              onClick={() => {
                if (rolesAssigned?.manageTenants) {
                  handleShowModal("modify tenant")
                }
              }}
            >
              <div className="icon-container">
                <CiEdit />
              </div>
              <div className="text">Edit</div>
            </div>
            <div
              className={`option alternate-option ${rolesAssigned?.manageTenants ? '' : 'disabled-option'}`}
              onClick={() => {
                if (rolesAssigned?.manageTenants) {
                  handleShowModal("move tenant")
                }
              }}
            >
              <div className="icon-container">
                <CgArrowsExchange />
              </div>
              <div className="text">Relocate</div>
            </div>
            <div
              className={`option ${rolesAssigned?.manageTenants ? '' : 'disabled-option'}`}
              onClick={() => {
                if (rolesAssigned?.manageTenants) {
                  handleShowModal("delete tenant")
                }
              }}
            >
              <div className="icon-container">
                <IoPersonRemoveOutline />
              </div>
              <div className="text">Remove</div>
            </div>
          </div>
        </div>
      </div>
      <div className="tenant-table-container">
        <div className="description" style={{ margin: "20px 0px" }}>
          Tenant List
        </div>
        <TenantTable
          handleShowModal={handleShowModal}
          setTenantData={setTenantData}
        />
      </div>

      {showModal && (
        <>
          <TenantModificationModal
            setShowPay={setShowModal}
            fieldToShow={action}
            tenantData={tenantData}
            setTenantData={setTenantData}
          />
        </>
      )}
    </div>
  );
};

export default MidSectionTenants;
